import { createFileRoute, Outlet, redirect, useParams } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { LoaderSpinner } from "@/components/ui/LoaderSpinner";
import { getAccessToken } from "@/utils/storage/authStorage";
import { getSubscriptionCourseOptions } from "@/api/queryOptions";
import { queryClient } from "@/main";
import type { CourseKey } from "@/api/api.types";

const CourseLayout = (): JSX.Element => {
	const { courseKey } = useParams({ from: "/(app)/_app/course/$courseKey" });
	const { data: subscription } = useSuspenseQuery(
		getSubscriptionCourseOptions(courseKey as CourseKey)
	);

	if (!subscription || !subscription.has_access) {
		return (
			<div className="py-3 px-safe-offset-3 min-h-[calc(100vh-176px)] flex items-center justify-center">
				<div className="text-center text-rose-500">
					Nie masz dostępu do tego kursu
				</div>
			</div>
		);
	}
	return <Outlet />;
};

export const Route = createFileRoute("/(app)/_app/course/$courseKey")({
	component: CourseLayout,
	beforeLoad: async ({ context, params }) => {
		const token =
			(context as { token: string | null }).token || (await getAccessToken());
		if (!token) {
			redirect({
				to: "/login",
				throw: true,
				search: { returnTo: `/course/${params.courseKey}` },
			});
		}
		await queryClient.ensureQueryData(
			getSubscriptionCourseOptions(params.courseKey as CourseKey)
		);
		return { token };
	},
	pendingComponent: () => (
		<div className="flex justify-center items-center h-screen">
			<LoaderSpinner className="p-3" size={6} />
		</div>
	),
});
